import getConfig from 'next/config';

import { CreditSelectionDevToolProvider } from 'shared/ui/CreditSelectionDevTool';

import { useDevAbExperiments } from 'entities/abExperiments';

export const DevToolsWrapper = ({ children }: { children: JSX.Element }) => {
  const { publicRuntimeConfig } = getConfig();
  const isProduction = publicRuntimeConfig.environment === 'production';
  const isDevToolEnabled = !!publicRuntimeConfig.isDevToolEnabled && !isProduction;

  useDevAbExperiments();

  if (isDevToolEnabled) {
    return <CreditSelectionDevToolProvider>{children}</CreditSelectionDevToolProvider>;
  }

  return children;
};
